import * as React from 'react';

import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import {TextField} from './textfield';
import {TextFieldDebounced} from './textfield-debounced';

type Props = {
    value: string;
    onChange: (val: string) => void;
    maxLength: number;
    placeholder?: string;
    isMultiLine?: boolean;
    isDisabled?: boolean;
    isDebouncedSave?: boolean;
    debouncedSaveDelay?: number;
    errorMessage?: string | null | undefined;
    onBlur?: () => void;
};

export function CharacterLimitedTextfield(props: Props) {
    const hasLengthError = props.value.length > props.maxLength;

    const textFieldProps = {
        placeholder: props.placeholder,
        value: props.value,
        // @ts-expect-error
        onChange: (val) => {
            props.onChange(val);
        },
        hasError: Boolean(props.errorMessage) || hasLengthError,
        multiline: props.isMultiLine,
        disabled: props.isDisabled,
        onBlur: props.onBlur,
    } as const;

    return (
        <Stack spacing={8}>
            {props.isDebouncedSave ? (
                <TextFieldDebounced {...textFieldProps} delay={props.debouncedSaveDelay || 200} />
            ) : (
                <TextField {...textFieldProps} />
            )}
            <Stack
                isHorizontal={true}
                justifyContent={props.errorMessage ? 'space-between' : 'end'}
            >
                {props.errorMessage && (
                    <Body color='error' size='small'>
                        {props.errorMessage}
                    </Body>
                )}
                <Body color={hasLengthError ? 'error' : undefined} size='small' textAlign='right'>
                    {props.value.length} / {props.maxLength} characters
                </Body>
            </Stack>
        </Stack>
    );
}
